const SET_FEATURE_FLAGS = (state, featureFlags) => {
  state.featureFlags = featureFlags
}

export default {
  SET_FEATURE_FLAGS,
}
